import * as Types from '../../generated.types'

import { PageInfoFragmentDoc } from '../../fragments/PageInfoFragment_gen'
import { EmployeeInfoFragmentDoc } from '../../fragments/EmployeeInfoFragment_gen'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type OrgEmployeeListQueryVariables = Types.Exact<{
  orgId: Types.Scalars['Int']
  first?: Types.InputMaybe<Types.Scalars['Int']>
  after?: Types.InputMaybe<Types.Scalars['String']>
  last?: Types.InputMaybe<Types.Scalars['Int']>
  before?: Types.InputMaybe<Types.Scalars['String']>
  searchTerms?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>
  accountStatuses?: Types.InputMaybe<Array<Types.EmployeeAccountStatus> | Types.EmployeeAccountStatus>
  employerId?: Types.InputMaybe<Types.Scalars['Int']>
}>

export type OrgEmployeeListQuery = {
  __typename?: 'Query'
  organization?: {
    __typename?: 'Organization'
    employees: {
      __typename?: 'EmployeeConnection'
      totalCount: number
      pageInfo: {
        __typename?: 'PageInfo'
        startCursor?: string | null
        endCursor?: string | null
        hasNextPage: boolean
        hasPreviousPage: boolean
      }
      nodes?: Array<{
        __typename?: 'Employee'
        id: number
        employmentStartDate?: string | null
        role: Types.EmployeeRole
        enrollmentInfo: {
          __typename?: 'EmployeeEnrollment'
          accountStatus: Types.EmployeeAccountStatus
          payrollSystemStatus?: Types.EmployeePayrollSystemStatusEnum | null
        }
        user: {
          __typename?: 'User'
          id: number
          email?: string | null
          firstName?: string | null
          lastName?: string | null
        }
        paygroupInfo: { __typename?: 'EmployerInfo'; id: number; name?: string | null }
        rosterEntryOverride?: {
          __typename?: 'RosterEntryOverride'
          payrollSystemStatus?: Types.EmployeePayrollSystemStatusEnum | null
        } | null
      } | null> | null
    }
  } | null
}

export const OrgEmployeeListDocument = `
    query OrgEmployeeList($orgId: Int!, $first: Int, $after: String, $last: Int, $before: String, $searchTerms: [String!], $accountStatuses: [EmployeeAccountStatus!], $employerId: Int) {
  organization(id: $orgId) {
    employees(
      first: $first
      after: $after
      last: $last
      before: $before
      searchTerms: $searchTerms
      accountStatuses: $accountStatuses
      employerId: $employerId
    ) {
      totalCount
      pageInfo {
        ...PageInfo
      }
      nodes {
        ...EmployeeInfo
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${EmployeeInfoFragmentDoc}`
export const useOrgEmployeeListQuery = <TData = OrgEmployeeListQuery, TError = Error>(
  variables: OrgEmployeeListQueryVariables,
  options?: UseQueryOptions<OrgEmployeeListQuery, TError, TData>
) =>
  useQuery<OrgEmployeeListQuery, TError, TData>(
    ['OrgEmployeeList', variables],
    fetchGql<OrgEmployeeListQuery, OrgEmployeeListQueryVariables>(OrgEmployeeListDocument, variables),
    options
  )

useOrgEmployeeListQuery.getKey = (variables: OrgEmployeeListQueryVariables) => ['OrgEmployeeList', variables]
